import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

interface FullscreenOverlayProps {
  active: boolean;
  testId?: string;
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1000;
  cursor: progress;
`;

const FullscreenOverlay = ({ active, testId }: FullscreenOverlayProps) => {
  if (!active) return null;
  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(<Overlay data-testid={testId} aria-busy="true" />, document.body);
};

export default FullscreenOverlay;
